<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-9">
                    <h3>Total Records : {{ duplicateRecords.length }}</h3>
                </div>
                <div class="col-md-3">
                    <a name="" id="select_all" class="btn btn-primary" href="javascript:void(0)" role="button" @click="selectAll">
                        {{ selectionTag }} All
                    </a>
                    &nbsp;
                    <template v-if="mergedRecordsIDS.length > 1"> 
                        <a name="" id="" class="btn btn-success" href="javascript:void(0)" role="button" @click="mergeCustomers">Merge Customers</a>
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <template v-if="duplicateRecords.length > 0">
                            <div class="col-md-4 mt-3" v-for="records in duplicateRecords" :key="records.id">
                                <!-- for card -->
                                <div class="card p-3">
                                    <div class="row">
                                        <div class="col-md-10"></div>
                                        <div class="col-md-2">
                                            <label class="custom-control custom-checkbox">
                                              <input type="checkbox" value="checkedValue" class="custom-control-input"
                                                    v-model="records.is_selected" @change="handleMegerdIDS">
                                              <span class="custom-control-indicator"></span>
                                              <span class="custom-control-description"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-dm-12">
                                            <div class="ml-3 w-100">
                                                <h4 class="mb-0 mt-0">
                                                    <router-link :to="{ name: 'customer-edit', params: { id: records.id }}">
                                                        {{ records.full_name }}
                                                    </router-link>
                                                </h4> 
                                                <span>
                                                    {{ records.email }}
                                                </span>
                                                <br/>
                                                <span>
                                                    Created On: {{ records.created_at | formatDate }}
                                                </span>
                                                <br>
                                                <span>
                                                    Post Code: {{ records.postcode }}
                                                </span>
                                                <div class="p-2 mt-2 bg-primary d-flex justify-content-between rounded text-white stats">
                                                    <div class="d-flex flex-column"> <span class="articles"> Total Bookings</span> 
                                                        <span class="number1">{{ records.bookings_count }}</span> 
                                                    </div>
                                                </div>
                                                <template v-if="mergedRecordsIDS.includes(records.id) && mergedRecordsIDS.length > 1">
                                                    <div class="p-2 mt-2 d-flex justify-content-between rounded text-white" style="color:black !important; float:right">
                                                        <div>
                                                            <label for="status">Mark as Main User</label>
                                                            &nbsp;
                                                            <label class="switch">
                                                                <input id="check_box" type="checkbox" :value="records.id" @change="setFaceUser($event)">
                                                                <span class="switch__slider"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- for card end-->
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DuplicateCustomerDetails',
    data() {
        return {
            selectionTag:'Select',
            duplicateRecords: [],
            mergedRecordsIDS: [],
            selectedMainUserID:null,
        }
    },
    created() {
        this.getRecords()
    },  
    methods: {
        getRecords() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'customers-merging/get-duplicate-record', {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    email:this.$route.params.email
                })
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if(response.status) {
                    this.duplicateRecords = response.data
                    this.duplicateRecords.forEach(obj => {
                        obj.is_selected = false;
                    });
                }
            })
        },
        selectAll() {
            let arrayofIDS = []
            let newRecords = this.duplicateRecords.map((element, index) => {
                if (element) {
                    element.is_selected = true
                    arrayofIDS.push(element.id)
                }

                return element
                
            })

            this.duplicateRecords = newRecords;
            
            if (arrayofIDS.length > 0) {
                this.mergedRecordsIDS = arrayofIDS; 
            }
        },
        setFaceUser(event) {
            // check if we are nabling or disabling the check box
            if (event.target.checked) {
                if (this.selectedMainUserID) {
                    this.$swal({
                        icon: "info",
                        title: "Can only select one Main User",
                    }).then(() => {
                        event.target.checked = false;
                    })
                } else {
                    this.selectedMainUserID = event.target.value
                }
                
            } else {
                this.selectedMainUserID = null
            }
        },
        handleMegerdIDS() {
            let arrayofIDS = []
            this.duplicateRecords.forEach((element) => {
                if (element.is_selected) {
                    arrayofIDS.push(element.id)
                }
            })

            if (arrayofIDS.length > 0) {
                this.mergedRecordsIDS = arrayofIDS; 
            }
        },
        mergeCustomers() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'customers-merging/merge-customers', {
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                },
                body: JSON.stringify({
                    selected_customer_ids: this.mergedRecordsIDS,
                    selected_main_customer:this.selectedMainUserID 
                })
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if(response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    this.mergedRecordsIDS = []
                    setTimeout(() => {
                        this.getRecords()
                    },500);
                }
            })
        }
    }        
}
</script>

<style lang="scss" scoped>

.stats {
    background: #f2f5f8 !important;
    color: #000 !important
}

.articles, .followers, .rating  {
    font-size: 18px;
    color: #a1aab9
}

.number1 {
    font-size: 15px;
    font-weight: 500
}

</style>